import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ROLES } from "@/lib/roles";
import { UserCircle2 } from "lucide-react";

const GROUPS = ["Medical", "Development", "Commercial", "Leadership", "Platform"];

export const RoleSwitcher = ({ roleId, onChange }) => (
  <div className="bg-white border border-slate-200/80 rounded-xl px-3 py-2 shadow-sm shadow-slate-100 flex items-center gap-2 shrink-0 self-start" data-testid="role-switcher">
    <UserCircle2 className="w-4 h-4 text-teal-600 shrink-0" />
    <Select value={roleId} onValueChange={onChange}>
      <SelectTrigger data-testid="role-select" className="h-6 border-0 shadow-none p-0 text-xs font-semibold text-slate-900 focus:ring-0 gap-1.5 w-auto">
        <span className="font-mono text-[9px] uppercase tracking-widest text-slate-400 mr-1">Role Lens</span>
        <SelectValue />
      </SelectTrigger>
        <SelectContent align="end">
          {GROUPS.map((g) => (
            <SelectGroup key={g}>
              <SelectLabel className="text-[10px] font-mono uppercase tracking-widest text-slate-400">{g}</SelectLabel>
              {ROLES.filter((r) => r.group === g).map((r) => (
                <SelectItem key={r.id} value={r.id} data-testid={`role-option-${r.id}`}>{r.label}</SelectItem>
              ))}
            </SelectGroup>
          ))}
        </SelectContent>
      </Select>
  </div>
);
